import { environment } from '../../../environments/environment';

export let Configuration = {
    adminApiUrl: environment.apiUrl,
    apiUrl: environment.apiUrl,
    metaDataURL: environment.metaDataURL,
    dashboardURL: environment.dashboardURL,

    // Env-driven so Stage B can flip per env to the upload-MS proxy URL
    // without redeploying. Defaults to the same env-driven environment.S3URL
    // so the two views (Configuration.s3URL and environment.S3URL) converge.
    s3URL: environment.S3URL,
    homePage: 'services',
};
